export default class CreatedAppointment {
  constructor (createdAppointment = {}) {
    this.appointmentId = createdAppointment.appointment_id || null
    this.phone = createdAppointment.message?.phone || null
    this.registrationLink = createdAppointment.registration_link || null
    this.redirectToRegistration = createdAppointment.redirect_to_registration || false
    this.status = createdAppointment.status || null
  }
}
